// src/components/common/OfflineBanner.js
import React, { useContext } from 'react';
import { ConnectivityContext } from '../../context/ConnectivityContext';

export default function OfflineBanner() {
  const { isOnline, queueCount, syncSummary } = useContext(ConnectivityContext);

  if (isOnline) {
    if (!syncSummary) return null;
    const conflicts = syncSummary.scoreConflicts.length + syncSummary.uploadFailures.length;
    const syncedCount = syncSummary.scoresSynced + syncSummary.uploadsSynced;
    if (syncedCount === 0 && conflicts === 0) return null;
    return (
      <div
        style={{
          background: conflicts > 0 ? '#fff3cd' : '#d1e7dd',
          color: conflicts > 0 ? '#664d03' : '#0f5132',
          padding: '0.5rem 1rem',
          textAlign: 'center',
          fontSize: '0.9rem'
        }}
      >
        {syncedCount > 0 && `Synced ${syncedCount} offline change(s). `}
        {conflicts > 0 && `${conflicts} item(s) need your attention - see the alerts on the affected page.`}
      </div>
    );
  }

  return (
    <div
      style={{
        background: '#dc3545',
        color: '#fff',
        padding: '0.5rem 1rem',
        textAlign: 'center',
        fontSize: '0.9rem',
        fontWeight: 500
      }}
    >
      You're offline. Your scoring and uploads are being saved on this device
      {queueCount > 0 ? ` (${queueCount} item(s) pending)` : ''} and will sync automatically once you're back online.
    </div>
  );
}
